import React, { useState } from "react";
import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Box,
  IconButton,
  TableContainer,
  Paper,
  Tooltip,
} from "@mui/material";
import { Edit, Delete, AttachFile } from "@mui/icons-material";
import ArticleIcon from "@mui/icons-material/Article";
import { Loading } from "../../sharedComponents/Loading";
import { ModalEditUser } from "./ModalEditUser";
import { ModalDeleteUser } from "./ModalDeleteUser";
import { ModalDocumentUser } from "./ModalDocumentUser";
import { ModalConfigClipping } from "./ModalConfigClipping";

export const UsersTable = ({ token, refresh, users, loading }) => {
  
  const [selectedUser, setSelectedUser] = useState(null);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openDocumentModal, setOpenDocumentModal] = useState(false);
  const [openConfigModal, setOpenConfigModal] = useState(false);

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Paper sx={{ width: "100%", overflow: "hidden" }} elevation={0}>
          <TableContainer
            sx={{ height: "calc(100vh - 300px)", overflowY: "auto" }}
          >
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  {["Nombre", "Email", "Rol", "Acciones"].map((title) => (
                    <TableCell
                      key={title}
                      style={{
                        fontWeight: "700",
                        backgroundColor: "#f1f1f1",
                        top: 0,
                        zIndex: 1,
                      }}
                    >
                      {title}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {users.map((user, index) => (
                  <TableRow
                    key={user.id}
                    sx={{
                      backgroundColor: index % 2 === 0 ? "white" : "#fafafa",
                    }}
                  >
                    <TableCell sx={{ fontSize: "13px" }}>
                      {user.user_name}
                      {user.permissions && user.permissions.length > 0 && (
                        <span
                          style={{
                            marginLeft: "8px",
                            fontSize: "10px",
                            backgroundColor: "#e0f2fe",
                            color: "#0369a1",
                            padding: "2px 10px",
                            borderRadius: "12px",
                          }}
                        >
                          {user.permissions.length} documento
                          {user.permissions.length > 1 ? "s" : ""}
                        </span>
                      )}
                    </TableCell>
                    <TableCell sx={{ fontSize: "13px" }}>
                      {user.email}
                    </TableCell>
                    <TableCell>
                      <span
                        style={{
                          backgroundColor: "#a3e635",
                          padding: "2px 10px",
                          borderRadius: "12px",
                          textTransform: "capitalize",
                          fontWeight: "600",
                          fontSize: "11px",
                        }}
                      >
                        {user.rol}
                      </span>
                    </TableCell>
                    <TableCell>
                      <Box sx={{ display: "flex" }}>
                        <Tooltip title="Configuración de Clipping" placement="top">
                          <span>
                            <IconButton
                              sx={{ color: "#2c3e50" }}
                              onClick={() => {
                                setSelectedUser(user);
                                setOpenConfigModal(true);
                              }}
                              disabled={!(user.permissions && user.permissions.length)}
                            >
                              <AttachFile />
                            </IconButton>
                          </span>
                        </Tooltip>
                        <Tooltip title="Documentos" placement="top">
                          <IconButton
                            sx={{ color: "#3b82f6" }}
                            onClick={() => {
                              setSelectedUser(user);
                              setOpenDocumentModal(true);
                            }}
                          >
                            <ArticleIcon />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Editar usuario" placement="top">
                          <IconButton
                            color="primary"
                            onClick={() => {
                              setSelectedUser(user);
                              setOpenEditModal(true);
                            }}
                          >
                            <Edit />
                          </IconButton>
                        </Tooltip>
                        <Tooltip title="Eliminar usuario" placement="top">
                          <IconButton
                            sx={{ color: "#ef4444" }}
                            onClick={() => {
                              setSelectedUser(user);
                              setOpenDeleteModal(true);
                            }}
                          >
                            <Delete />
                          </IconButton>
                        </Tooltip>
                      </Box>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <ModalDocumentUser
              open={openDocumentModal}
              onClose={() => setOpenDocumentModal(false)}
              selectedUser={selectedUser}
              token={token}
              refresh={refresh}
            />
            <ModalEditUser
              open={openEditModal}
              onClose={() => setOpenEditModal(false)}
              selectedUser={selectedUser}
              token={token}
              refresh={refresh}
            />
            <ModalDeleteUser
              open={openDeleteModal}
              onClose={() => setOpenDeleteModal(false)}
              selectedUser={selectedUser}
              token={token}
              refresh={refresh}
            />
            <ModalConfigClipping
              open={openConfigModal}
              onClose={() => setOpenConfigModal(false)}
              token={token}
              user={selectedUser}
            />
          </TableContainer>
        </Paper>
      )}
    </>
  );
};
